import React from 'react'
import { withPrefix } from 'gatsby';
import { ExclamationCircle } from '../../../../../svg/exclamation_circle'
import s from './index.module.css'

const EstoyObligadoAAportarSiTengoMasDe65Anios = () => {
  return (
    <div className={'containerWrap'}>
      <div className={`flex@lg`}>
        <div className={`w-100 w-50@lg tw-pr-2@lg tw-pr-4@lg`}>
          <div className="c-gray--4 tw-mb-6 tw-mb-2@lg center left@lg">
            <h3 className="font-family-secondary fw-7 tw-f-20 tw-f-24@lg tw-m-0">
              ¿Estoy obligado a aportar si tengo más de 65 años?
            </h3>
          </div>

          <div className="font-family-primary c-gray--4 tw-mb-4 tw-mb-4@lg center left@lg">
            <p className="fw-0 tw-f-16 tw-f-16@lg tw-mb-4">
              En caso cumplas 65 años, no decidas jubilarte y continúes
              laborando como trabajador dependiente, deberás seguir
              realizando el aporte obligatorio a tu fondo y pagar la
              comisión por administración.
            </p>
          </div>

          <div className="flex@lg center">
            <img
              src={withPrefix('/images/pantuflas.svg')}
              alt="pantuflas"
              height="120px"
              className={`tw-mr-10@lg`}
            />

            <div className="brad-4 font-family-primary border border-yellow-0 bg-yellow-1 tw-p-6 left">
              <p className="tw-f-16 tw-f-20@lg">
                <strong>Sin embargo...</strong> <br></br>
              </p>

              <p className="tw-f-12 tw-f-16@lg tw-mb-4">
                Ya no deberás realizar el pago de la Prima de Seguro que
                cubre los riesgos de invalidez, sobrevivencia y gastos de
                sepelio, para lo cual deberás comunicarle a tu empleador que
                has cumplido 65 años de edad.
              </p>
            </div>
          </div>

          <div className={`brad-4 bg-white tw-p-4 font-family-primary tw-f-16 tw-f-16@lg tw-mt-4`}>
            <div className={`flex`}>
              <div className={`tw-mr-2`}>
                <ExclamationCircle fill={'#000000'} />
              </div>

              <div>
                En caso te jubiles y sigas laborando como trabajador
                dependiente, no deberás realizar ningún aporte a la AFP,
                para lo cual deberás comunicarle a tu empleador tu condición
                de jubilado.
              </div>
            </div>
          </div>
        </div>

        <div className={`w-auto w-50@lg tw-pt-12 tw-pt-16@lg`}>
          <img
            src={withPrefix('/images/woman-piggy-bank.svg')}
            alt="woman-piggy-bank"
            className={`${s.imagenBox11} z-10`}
          />
        </div>
      </div>

      <div className={`border border-turquoise-0 brad-4 bg-turquoise-1 tw-p-8 tw-p-4@lg font-family-primary tw-f-16 tw-f-16@lg`}>
        <div className={`flex direction-column direction-row@lg items-center center left@lg`}>
          <div className={`tw-mr-2 tw-mr-6@lg`}>
            <img
              src={withPrefix('/images/finger-pressing.svg')}
              alt="finger-pressing"
              className={`${s.imagenBox6}`}
            />
          </div>

          <div className="tw-mt-2 tw-mt-0@lg">
            <span className={`c-orange-0 b tw-f-18`}>
              ¿Quién paga mi aporte a la AFP?
            </span>

            <br></br>

            Tu empleador es el responsable de descontar un procentaje de tu
            sueldo para tu aporte obligatorio y realizar el pago de tu AFP.
          </div>
        </div>
      </div>
    </div>
  )
};

export default EstoyObligadoAAportarSiTengoMasDe65Anios;
